import { Button, Modal, Stack, styled, Typography } from "@mui/material";
import SbLogoLightSmall from "../../icons/SbLogoLightSmall.svg?react";

const BoxModalContainer = styled(Stack)(({ theme }) => ({
  height: "fit-content",
  width: "fit-content",
  gap: "20px",
  background: theme.palette.surfaceLight30.main,
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "4px",
  padding: "24px",
}));

type LoadingModalProps = {
  showLoadingModal: boolean;
  handleCancel: () => void;
  text: string;
};

const LoadingModal = ({ showLoadingModal, handleCancel, text }: LoadingModalProps) => {
  return (
    <Modal open={showLoadingModal} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <BoxModalContainer>
        <SbLogoLightSmall width="48px" height="48px" data-testid="sb-light-logo-small" />
        <Typography variant="heading.five" sx={{ color: "text50.main" }}>
          {text}
        </Typography>
        <Button variant="text" color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
      </BoxModalContainer>
    </Modal>
  );
};

export { LoadingModal };
